import React from 'react';
import LazyLoad from 'react-lazyload';
import { Heading, Link, Image, Paragraph, IconSVG } from 'components';
import {
  getArticleSlug,
  estimateReadTime,
  getCloudinaryUrl,
} from 'config/helpers';
import './BoxBlogPost.scss';

const BoxBlogPost = ({ data, contributors, node, theme, id }) => {
  const {
    box,
    content,
    settings: articleSettings,
    cover: articleCover,
    title: articleTitle,
    contributor,
  } = data;
  const { content: boxContent } = box || {};
  const { title: customTitle, coverImage: customCover } = boxContent || {};

  const title = customTitle || articleTitle;
  const cover = customCover || articleCover;
  const contributorData = contributors.filter(
    edge => edge.node.frontmatter.title === contributor,
  );

  let articlePureContent = '';
  if (content && typeof content !== 'undefined') {
    articlePureContent = content
      .reduce((a, b) => a.body || a + b.body, '')
      .replace(/[^a-zA-Z ]/g, ' ');
  }

  const readTime = estimateReadTime(articlePureContent);

  return (
    <Link to={getArticleSlug(node)} id={id}>
      <div
        className={`box-blog-post ${theme ? `box-blog-post--${theme}` : ''}`}
      >
        <div className={'box-blog-post__top'}>
          <LazyLoad once offset={200} height={200}>
            <Image
              src={getCloudinaryUrl(cover, 'f_auto,q_auto,h_300')}
              alt={title}
            />
          </LazyLoad>
        </div>
        <div className={'box-blog-post__bottom'}>
          <div
            className={`box-blog-post__info ${
              theme === 'black' ? 'box-blog-post__info--black' : ''
            }`}
          >
            {articleSettings.category}
            {articlePureContent && (
              <>
                <Paragraph
                  size={'small'}
                  additionalClass={'box-blog-post__time'}
                >
                  {readTime} min read
                </Paragraph>
                <IconSVG name={'time'} color={'black'} />
              </>
            )}
          </div>
          <div className={'box-blog-post__content'}>
            <Heading type={3} size={'medium'}>
              {title}
            </Heading>
            {contributorData.length > 0 && (
              <div className={'box-blog-post__contributor'}>
                <Image
                  src={getCloudinaryUrl(
                    contributorData[0].node.frontmatter.photo,
                    'f_auto,q_auto,w_100',
                  )}
                  alt={`${contributorData[0].node.frontmatter.title} avatar`}
                  placeholder
                />
                <Paragraph size={'small'}>
                  {contributorData[0].node.frontmatter.title}
                  <br />
                  <span className={'text--light'}>
                    {contributorData[0].node.frontmatter.job}
                  </span>
                </Paragraph>
              </div>
            )}
          </div>
        </div>
      </div>
    </Link>
  );
};

BoxBlogPost.defaultProps = {
  theme: 'white',
  contributors: [],
};

export default BoxBlogPost;
